export enum SystemItemTypes {
  Product = "Product",
  Membership = "Membership",
  Service = "Service",
  Donation = "Donation",
}
export enum SelectItemTypes {
  All = "All Types",
  Product = "Product",
  Membership = "Membership",
  Service = "Service",
}

export enum ItemDropDownOptions {
  Activity = "Activity",
  Contacts = "Contacts",
  Orders = "Orders",
  Donations = "Donations",
  Items = "Items",
  Payments = "Payments",
  Invoices = "Invoices",
  Quotes = "Quotes",
  Subscriptions = "Subscriptions",
  Checkout = "Checkout",
  Funding = "Funding",
  Disputes = "Disputes",
  Promotions = "Promotions",
  Tax = "Tax",
  PaymentSettings = "Payment Settings",
  MerchantAccounts = "Merchant Accounts",
  PurchaseLink = "Purchase Link",
}
